import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, KeepAlive as _KeepAlive } from "vue"

const _hoisted_1 = { class: "p-the-page-g01 c-common-footer-fixed" }
const _hoisted_2 = { class: "c-common-footer-fixed__inner" }
const _hoisted_3 = { class: "c-common-inner" }
const _hoisted_4 = { class: "p-the-page-g01__body" }
const _hoisted_5 = { class: "p-the-page-g01__inner" }
const _hoisted_6 = { class: "p-the-page-g01__tab" }
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheBreadcrumb = _resolveComponent("TheBreadcrumb")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TheHeader, { ref: "theHeader" }, null, 512),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TheBreadcrumb),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[0] || (_cache[0] = _createElementVNode("p", { class: "p-the-page-g01__heading" }, "ランキング", -1)),
            _createElementVNode("ul", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: tab.value,
                  class: _normalizeClass(["p-the-page-g01__tab__item", { active: tab.value === _ctx.active }]),
                  style: _normalizeStyle({ 'border-color': _ctx.colorCode }),
                  onClick: ($event: any) => (_ctx.active = tab.value)
                }, _toDisplayString(tab.label), 15, _hoisted_7))
              }), 128))
            ])
          ]),
          (_openBlock(), _createBlock(_KeepAlive, null, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.selectedContent), { class: "p-the-page-g01__content" }))
          ], 1024))
        ])
      ])
    ]),
    _createVNode(_component_TheFooter)
  ]))
}